"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readAsArrayBufferAsync = exports.readAsDataURLAsync = exports.readFileAsTextAsync = void 0;
function readFileAsTextAsync(file) {
    // Always return a Promise
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = function (e) { resolve(e.target.result); };
        reader.onerror = function (e) { reject(e.target.error.message); };
        reader.readAsText(file);
    });
}
exports.readFileAsTextAsync = readFileAsTextAsync;
function readAsDataURLAsync(file) {
    // Always return a Promise
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = function (e) { resolve(e.target.result); };
        reader.onerror = function (e) { reject(e.target.error.message); };
        reader.readAsDataURL(file);
    });
}
exports.readAsDataURLAsync = readAsDataURLAsync;
function readAsArrayBufferAsync(file) {
    // Always return a Promise
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = function (e) { resolve(e.target.result); };
        reader.onerror = function (e) { reject(e.target.error.message); };
        reader.readAsArrayBuffer(file);
    });
}
exports.readAsArrayBufferAsync = readAsArrayBufferAsync;
//# sourceMappingURL=files.js.map